import type { ArticleResult } from '../../types';
import { MetricsGrid } from './MetricsGrid';

function TextList({ value, empty }: { value?: string; empty: string }) {
  const items = (value || '')
    .split(/\n+/)
    .map((item) => item.replace(/^[-*]\s*/, '').trim())
    .filter(Boolean);
  return (
    <ul className="clean">
      {items.length ? (
        items.map((item, index) => <li key={`${index}-${item}`}>{item}</li>)
      ) : (
        <li className="muted-item">{empty}</li>
      )}
    </ul>
  );
}
export function ArticleResultPanel({
  article,
  retrying,
  onRetry
}: {
  article: ArticleResult;
  retrying: boolean;
  onRetry: () => void;
}) {
  const failed = article.status === 'failed' || article.status === 'timeout';
  return (
    <section className={`article-result status-${article.status}`}>
      <div className="article-result-head">
        <div>
          <h4>文章 {article.slot}</h4>
          <span>{article.title || '未填写标题'}</span>
        </div>
        <span className={`status-badge status-${article.status}`}>
          {failed ? '本篇未完成' : '评测完成'}
        </span>
      </div>
      {failed ? (
        <div className="failure-box">
          <strong>{article.failure_message || '本篇评测未完成'}</strong>
          <p>
            错误分类：{article.failure_code || 'workflow_failed'}。已成功的另一篇结果不会受到影响。
          </p>
          {article.retryable && (
            <button className="btn secondary" disabled={retrying} onClick={onRetry}>
              {retrying ? '重新提交中…' : '重试本篇'}
            </button>
          )}
        </div>
      ) : (
        <>
          <MetricsGrid article={article} />
          <div className="insights">
            <div className="summary-box">
              <h4>写得好的地方</h4>
              <TextList value={article.strengths} empty="暂无明确优势信息" />
            </div>
            <div className="summary-box">
              <h4>需要注意的问题</h4>
              <TextList value={article.issues_to_note} empty="暂无明显高风险问题" />
            </div>
          </div>
          <div className="summary-box">
            <h4>优先优化建议</h4>
            <TextList
              value={article.priority_optimization_suggestions}
              empty="建议继续补强证据来源与结构化摘要"
            />
          </div>
        </>
      )}
    </section>
  );
}
